import { CSE_SERVER_COMMAND } from '@telemetry/services/telemetry.service';

export { Permission } from './permissions';
export type { PermissionKey } from './permissions';
export { NAV_SECTIONS } from './nav-config';
export type { NavItem, NavSection } from './nav-config';

export const VEHICLE_CATEGORIES = [
  { label: 'Sedan', value: 'sedan' },
  { label: 'SUV', value: 'suv' },
  { label: 'Hatchback', value: 'hatchback' },
  { label: 'MPV', value: 'mpv' },
  { label: 'Coupe', value: 'coupe' },
  { label: 'Pickup', value: 'pickup' },
  { label: 'Van', value: 'van' },
  { label: 'Convertible', value: 'convertible' },
  { label: 'Lorry', value: 'lorry' },
  { label: 'Wagon', value: 'wagon' },
  { label: 'Micro Car', value: 'micro-car' },
  { label: 'Limousine', value: 'limousine' },
  { label: 'Others', value: 'others' },
];

export const FUEL_TYPES = [
  { label: 'RON95', value: 'ron95' },
  { label: 'RON97', value: 'ron97' },
  { label: 'Diesel', value: 'diesel' },
  { label: 'Electric', value: 'electric' },
  { label: 'Hybrid', value: 'hybrid' },
];

export type TelemetryMenu = {
  label: string;
  icon: string;
  value: 'cdmaSignal' | 'oilLevel' | 'voltage' | 'engine' | 'speed' | 'light';
};

export type CmdMenu = {
  label: string;
  icon: string;
  command: CSE_SERVER_COMMAND;
};

export const TELEMETRY_MENU: TelemetryMenu[] = [
  {
    label: 'Engine',
    icon: 'Engine.png',
    value: 'engine',
  },
  {
    label: 'Fuel Level',
    icon: 'Petrol.png',
    value: 'oilLevel',
  },
  {
    label: 'Voltage',
    icon: 'Voltage.png',
    value: 'voltage',
  },
  {
    label: 'Signal',
    icon: 'Signal.png',
    value: 'cdmaSignal',
  },
  {
    label: 'Speed',
    icon: 'Speed.png',
    value: 'speed',
  },
  {
    label: 'Head Light',
    icon: 'Head-light.png',
    value: 'light',
  },
];

export const TELEMETRY_CMD: CmdMenu[] = [
  {
    label: 'Door Lock',
    icon: 'lock.png',
    command: CSE_SERVER_COMMAND.APP_DOOR_LOCK_A,
  },
  {
    label: 'Door Unlock',
    icon: 'Unlock.png',
    command: CSE_SERVER_COMMAND.APP_DOOR_UNLOCK_B,
  },
  {
    label: 'Horn',
    icon: 'horn.png',
    command: CSE_SERVER_COMMAND.APP_HORN,
  },
  {
    label: 'Blinker Light',
    icon: 'Harzard-light.png',
    command: CSE_SERVER_COMMAND.APP_BLINKER,
  },
];
